<div class="modal-header">
  <h4 class="modal-title pull-left">회원상세</h4>
  <button type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="modalService.hide()">
    <span aria-hidden="true"
      class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card">
    <div class="card-body">
      <div class="table-responsive"
        *ngIf="userData">
        <table class="table table-nowrap mb-0">
          <tbody>
            <tr>
              <th scope="row">가입일 :</th>
              <td>{{ userData.createdAt.toDate() | date : "yyyy.MM.dd HH:mm" }}</td>
            </tr>
            <tr>
              <th scope="row">회원이름 :</th>
              <td>{{ userData.name }}</td>
            </tr>
            <tr>
              <th scope="row">이메일주소 :</th>
              <td>{{ userData.email }}</td>
            </tr>
            <tr>
              <th scope="row">연락처 :</th>
              <td>{{ userData.phone || '-' }}</td>
            </tr>
            <tr>
              <th scope="row">회원상태 :</th>
              <td>
                <span [class]="getStatusClass(userData.status)">
                  {{ getStatusText(userData.status) }}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row">입주구분 :</th>
              <td>{{ getUpperLevelName(user) }}</td>
            </tr>
            <tr>
              <th scope="row">세대주 구분 :</th>
              <td>
                <span [class]="getHouseholdStatusClass(userData)">
                  <i [class]="getHouseholdStatusIcon(userData)"></i>
                  {{ getHouseholdStatusText(userData) }}
                </span>
              </td>
            </tr>

            <!-- <tr>
              <th scope="row">거주타입 :</th>
              <td>{{ getUpperLevelName(user.upper_level_name) }}</td>
            </tr> -->
            <tr>
              <th scope="row">본인인증 :</th>
              <td>
                <span [class]="userData.isCertified ? 'badge bg-success' : 'badge bg-warning'">
                  {{ userData.isCertified ? '인증완료' : '미인증' }}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row">마케팅 알림 동의 :</th>
              <td>
                <span [class]="userData.marketingAgree ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ userData.marketingAgree ? '동의' : '미동의' }}
                </span>
              </td>
            </tr>
            <tr *ngIf="userData.marketingAgree">
              <th scope="row">마케팅 동의일 :</th>
              <td>{{ userData.dateMarketingAgreed.toDate() | date : "yyyy.MM.dd" }}</td>
            </tr>
            <tr>
              <th scope="row">푸시 알림 :</th>
              <td>
                <span [class]="userData.pushSwitch ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ userData.pushSwitch ? '활성화' : '비활성화' }}
                </span>
              </td>
            </tr>


            <tr *ngIf="userData.headofhouseholdId">
              <th scope="row">세대주 :</th>
              <td>{{ userData.headofhouseholdId.name }}</td>
            </tr>
            <tr *ngIf="userData.householdUserIds && userData.householdUserIds.length > 0">
              <th scope="row">세대원 :</th>
              <td>
                <span class="badge bg-primary"
                  *ngFor="let user of removeUser(userData.householdUserIds)"
                  style="margin-right: 5px;">
                  {{ user.name }}
                </span>
              </td>
            </tr>
            <tr *ngIf="userData.certifiedId">
              <th scope="row">인증 ID :</th>
              <td>{{ userData.certifiedId.id }}</td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button"
    class="btn btn-default"
    (click)="modalService.hide()">
    닫기
  </button>
</div>

<div bsModal
  #modalReason="bs-modal"
  id="modalReason"
  class="modal fade bs-example-modal-lg"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <!-- 여기에 modal-dialog-centered 추가 -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title add-task-title">탈퇴사유</h5>
        <button type="button"
          class="btn-close"
          (click)="modalReason.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="card mb-4">
            <div class="card-body">
              <div class="form-group mb-3"
                *ngIf="withdrawalData">
                <label for="taskname"
                  class="col-form-label">선택사유<span class="text-danger"></span></label>
                <div class="col-lg-12">
                  <input id="taskname"
                    name="taskname"
                    type="text"
                    class="form-control validate"
                    [(ngModel)]="withdrawalData.reason_type"
                    disabled />
                </div>
              </div>
              <div class="form-group mb-3"
                *ngIf="withdrawalData">
                <label class="col-form-label">상세사유</label>
                <div class="col-lg-12">
                  <textarea id="taskdesc"
                    class="form-control"
                    name="taskdesc"
                    disabled
                    [(ngModel)]="withdrawalData.reason"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end row-->

        <div class="row">
          <div class="text-end mb-4">
            <button type="submit"
              (click)="modalReason.hide()"
              class="btn btn-primary">
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->